
export abstract class InputValidation {

    public static onlyUrlFriendlyCharsRegEx = /[^a-zA-Z0-9_-]+/;

    public static required = value =>
        (!!value || value === '0' || value === 0) || 'Value is missing';

    public static number = value =>
        (!isNaN(Number(value))) || 'Value is not a number';

    public static lessThanThousand = value =>
        ((value < 1000)) || 'Value must be less than 1000 px';

    public static largerThanZero = value =>
        ((!!value || value === '0' || value === 0) && (value > 0)) || 'Value must be larger than zero';

    public static nonNegative = value =>
        ((!!value || value === '0' || value === 0) && (value >= 0)) || 'Value must not be negative';
    
    public static noSpaces = value =>
        !/\s/.test(value) || 'Value must not contain spaces'

    public static noSpecialSigns = value =>
        !/[^a-zæøåA-ZÆØÅ0-9_-\s\.]+/.test(value) || 'Value must not contain special characters'

    public static onlyUrlFriendlyChars = value =>
        !InputValidation.onlyUrlFriendlyCharsRegEx.test(value) || 'Only A-Z, dash and underscore are allowed'

    public static min8Chars = value => value && value.length >= 8 || 'Value must contain at least 8 characters'

    public static email = value =>
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Value is not a valid email address'

    public static arrayNotEmpty = value => value && value.length > 0 || 'You have to select at least one option'
}
